const staff = {
  state: {
    paymentBtnLoading: false,
    makeInvoiceBtnLoading: false
  },
  mutations: {
    setPaymentBtnLoading(state, data) {
      state.paymentBtnLoading = data;
    },
    setMakeInvoiceBtnLoading(state, data) {
      state.makeInvoiceBtnLoading = data;
    }
  },
  namespaced: true,
  actions: {
    async getPurchaseList({ rootState }, params = {}) {
      const data = await rootState.http("purchase/queryList", params);
      return data;
    },
    async savePurchase({ rootState }, params = {}) {
      const data = await rootState.http("purchase/savePurchase", params);
      return data;
    },
    async getPurchaseDetail({ rootState }, params = {}) {
      const data = await rootState.http("purchase/getPurchase", params);
      return data;
    },
    async purchaseComplete({ rootState }, params = {}) {
      const data = await rootState.http("purchase/completed", params);
      return data;
    },
    async purchaseInbound({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/purchaseBatchWarehousing", params);
      return data;
    },
    async purchaseCancel({ rootState }, params = {}) {
      const data = await rootState.http("purchase/cancel ", params);
      return data;
    },
    async createPurchasePayment({ rootState }, params = {}) {
      const data = await rootState.http("/payment/createPaymentPurchase", params);
      return data;
    },
    async createQuickPurchase({ rootState }, params = {}) {
      const data = await rootState.http("/order/quickPurchase", params);
      return data;
    },
    // 采购退货
    // 列表
    async getReturnPurchasePageModelPage({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/return/getReturnPurchasePageModelPage", params);
      return data;
    },
    // 详情
    async getReturnPurchaseModel({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/return/getReturnPurchaseModel", params);
      return data;
    },
    // 创建 编辑
    async saveReturnPurchase({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/return/v2/saveReturnPurchase", params);
      return data;
    },
    // 出库
    async outBoundReturnPurchase({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/return/v2/outBoundReturnPurchase", params);
      return data;
    },
    // 取消
    async cancelReturnPurchase({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/return/cancelReturnPurchase", params);
      return data;
    },
    // 收款
    async receiveReturnPurchase({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/return/receiveReturnPurchase", params);
      return data;
    },
    // 获取采购信息
    async getPurchaseModel({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/findPurchaseInboundDetails", params);
      return data;
    },
    // 获取采购选择信息列表
    async getPurchaseSelectModelList({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/getPurchaseSelectModelList", params);
      return data;
    },
    // 查询快速采购详情
    async queryOrderQuickPurchaseList({ rootState }, params = {}) {
      const data = await rootState.http("/purchase/workorder/partsList", params);
      return data;
    }
  }
};

export default staff;
